import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const isCorporateTax = location.pathname === '/corporate-tax';

  // Variant 1: Corporate Tax Footer
  if (isCorporateTax) {
    return (
      <footer className="site-footer">
        <style>{`
          .site-footer {
            background: #ffffff !important;
            color: #31435A !important;
            border-top: 1px solid #E4EBF2;
            padding-block: clamp(46px, 5vw, 68px) 0;
          }
          .site-footer h3 {
            color: #14365C !important;
            font-weight: 700;
          }
          .site-footer a {
            color: #31435A !important;
            text-decoration: none;
            transition: color .18s ease;
          }
          .site-footer a:hover {
            color: #C9932B !important;
            text-decoration: underline;
          }
          .site-footer .foot-about {
            color: #31435A !important;
            line-height: 1.7;
          }
          .site-footer address {
            color: #31435A !important;
            font-style: normal;
            line-height: 1.7;
          }
          .site-footer .privacy-note {
            background: #F8FAFC !important;
            border: 1px solid #E2E8F0 !important;
            color: #31435A !important;
            border-radius: 12px;
            padding: 24px;
            margin-top: 36px;
          }
          .site-footer .privacy-note h3 {
            color: #14365C !important;
            margin-top: 0;
            margin-bottom: 12px;
          }
          .site-footer .privacy-note p {
            margin: 0;
            line-height: 1.6;
            font-size: 0.92rem;
            color: #31435A !important;
          }
          .site-footer .privacy-note p + p {
            margin-top: 10px;
          }
          .site-footer .privacy-note a {
            color: #31435A !important;
            text-decoration: underline !important;
          }
          .site-footer .privacy-note a:hover {
            color: #C9932B !important;
          }
          .site-footer .foot-bottom {
            border-top: 1px solid #E4EBF2 !important;
            color: #31435A !important;
            margin-top: 36px;
            padding-block: 24px;
            display: flex;
            justify-content: space-between;
            gap: 16px;
            font-size: 0.85rem;
          }
        `}</style>

        <div className="shell">
          <div className="foot-grid">
            <div className="foot-brand">
              <a className="brand" href="#top" style={{ margin: 0, display: 'block' }}>
                <img
                  src="/standard-auditing-logo-1.png"
                  alt="Standard Auditing"
                  style={{ height: '40px', width: 'auto', display: 'block' }}
                />
              </a>
              <p className="foot-about">
                Audit, tax and accounting for UAE businesses since 2000. Members of the Emirates Association for
                Accountants and Auditors.
              </p>
            </div>

            <div>
              <h3>Contact</h3>
              <ul className="foot-list">
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#31435A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <a href="tel:+971542119784" style={{ color: '#31435A', fontWeight: 600 }}>+971 54 211 9784</a>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#31435A" style={{ flexShrink: 0 }}>
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                  </svg>
                  <a href="https://wa.me/971542119784" target="_blank" rel="noopener noreferrer" style={{ color: '#31435A', fontWeight: 600 }}>
                    WhatsApp us
                  </a>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#31435A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <a href="mailto:Sales@standardauditors.com" style={{ color: '#31435A', fontWeight: 600 }}>Sales@standardauditors.com</a>
                </li>
              </ul>
            </div>

            <div>
              <h3>Office</h3>
              <ul className="foot-list">
                <li style={{ display: 'flex', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#31435A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: '3px' }}>
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <address>
                    Standard Auditing
                    <br />
                    NBQ Building 112
                    <br />
                    Khalid Bin Al Waleed Road
                    <br />
                    Al Hamriya, Dubai
                    <br />
                    United Arab Emirates
                  </address>
                </li>
              </ul>
            </div>

            <div>
              <h3>On this page</h3>
              <ul className="foot-list">
                <li>
                  <a href="#register">Do you have to register?</a>
                </li>
                <li>
                  <a href="#pricing">What filing costs</a>
                </li>
                <li>
                  <a href="#process">How the process works</a>
                </li>
                <li>
                  <a href="#penalties">Late filing penalties</a>
                </li>
                <li>
                  <a href="#compare">Filing it yourself</a>
                </li>
                <li>
                  <a href="#about">About Standard Auditing</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
              </ul>
            </div>
          </div>

          <div id="privacy" className="privacy-note">
            <h3>How we handle your data</h3>
            <p>
              The form on this page collects your name, company, email and phone number for one purpose: so a Standard
              Auditing accountant can contact you about your UAE Corporate Tax filing. We do not sell your details, we
              do not pass them to third party marketing, and we do not use them for anything you did not ask for. Ask us
              to delete your record at any time by emailing{' '}
              <a href="mailto:Sales@standardauditors.com">Sales@standardauditors.com</a> and we will remove it.
            </p>
            <p className="tiny" style={{ marginTop: '10px', opacity: 0.8 }}>
              This summary sits on the page deliberately, so you never have to leave it to read it. It does not replace
              the firm's full privacy policy.
            </p>
          </div>

          <div className="foot-bottom">
            <span>&copy; 2026 Standard Auditing. All rights reserved.</span>
            <span>Corporate Tax guidance on this page is general information, not tax advice. Last reviewed 31 July 2026.</span>
          </div>
        </div>
      </footer>
    );
  }

  // Variant 2: Audit Consulting Footer
  return (
    <footer className="home-footer" data-screen-label="Footer">
      <style>{`
        .home-footer {
          background: #1A231E;
          border-top: 1px solid rgba(252, 253, 254, 0.12);
          padding: 56px 48px 28px;
          color: #D8D2C2;
          text-align: left;
        }
        .home-foot-grid {
          max-width: 1120px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1.3fr 1fr 1fr;
          gap: 48px;
        }
        .home-foot-col {
          display: flex;
          flex-direction: column;
          gap: 10px;
          font-size: 13.5px;
        }
        .home-foot-col h3 {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          color: #FBFAF6;
          font-size: 14px;
          margin-top: 0;
          margin-bottom: 4px;
        }
        .home-foot-col a {
          color: #D8D2C2;
          text-decoration: none;
          transition: color .18s ease;
        }
        .home-foot-col a:hover {
          color: #B5652E;
        }
        @media (max-width: 900px) {
          .home-foot-grid {
            grid-template-columns: 1.2fr 1fr;
            gap: 32px;
          }
        }
        @media (max-width: 600px) {
          .home-foot-grid {
            grid-template-columns: 1fr;
            gap: 24px;
          }
        }
      `}</style>

      <div className="home-foot-grid">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <img
            src="/standard-auditing-logo-1.png"
            alt="Standard Auditing"
            style={{ height: '40px', width: 'auto', display: 'block', alignSelf: 'flex-start' }}
          />
          <p style={{ margin: 0, fontSize: '13px', lineHeight: 1.7, maxWidth: '44ch', color: '#D8D2C2' }}>
            Independent private tax and audit consulting firm based in Dubai, UAE. We are not affiliated with the Federal
            Tax Authority (FTA) or any UAE government entity, and we do not issue government documents or official
            services.
          </p>
          <div style={{ fontSize: '12.5px', color: '#8A8377' }}>Trade License No. 795106</div>
        </div>

        <div className="home-foot-col">
          <h3>Contact</h3>
          <a href="tel:+971542119784">+971 54 211 9784</a>
          <a href="https://wa.me/971542119784" target="_blank" rel="noopener noreferrer">
            WhatsApp Us
          </a>
          <div style={{ color: '#D8D2C2', lineHeight: 1.6, marginTop: '4px' }}>
            Standard Auditing, NBQ Building – 112
            <br />
            Khalid Bin Al Waleed Rd, Al Mankhool
            <br />
            Dubai, United Arab Emirates
          </div>
        </div>

        <div className="home-foot-col">
          <h3>Legal</h3>
          <a href="#privacy">Privacy Policy</a>
          <a href="#terms">Terms of Service</a>
          <a href="#refund">Refund &amp; Cancellation Policy</a>
        </div>
      </div>

      <div
        style={{
          maxWidth: '1120px',
          margin: '32px auto 0',
          borderTop: '1px solid rgba(252, 253, 254, 0.12)',
          paddingTop: '20px',
          fontSize: '12px',
          color: '#8A8377',
          textAlign: 'center',
        }}
      >
        © 2026 Standard Auditing. All rights reserved. Independent private advisory firm — not a government authority.
      </div>
    </footer>
  );
};

export default Footer;
